import apiSlice from "./ApiSlice";

export const couponApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // GET ALL With PAGINATION
    getAllCouponWithPagination: builder.query({
      providesTags: ["coupon"],
      query: (body) => {
        return {
          url: "/coupon",
          method: "POST",
          body
        };
      },
    }),

    // Add
    addCoupon: builder.mutation({
      invalidatesTags: ["coupon"],
      query: (body) => {
        return {
          url: "/coupon/add",
          method: "POST",
          body,
        };
      },
    }),

    // EDIT
    editCoupon: builder.mutation({
      invalidatesTags: ["coupon"],
      query: ({ body, id }: any) => {
        return {
          url: `/coupon/${id}`,
          method: "PUT",
          body,
        };
      },
    }),

    //Single View
    viewCouponById: builder.query({
      providesTags: ["coupon"],
      query: (id: any) => {
        return {
          url: `/coupon/${id}`,
          method: "GET",
        };
      },
    }),
    // GET COUPON DETAILS
    getCouponByCode: builder.mutation({
      query: ({
        couponCode,
        studentId,
      }: {
        couponCode: any;
        studentId: string;
      }) => {
        return {
          url: `/coupon/get-by-code/${couponCode}/student/${studentId}`,
          method: "GET",
        };
      },
    }),

    // Delete
    deleteCoupon: builder.mutation({
      invalidatesTags: ["coupon"],
      query: (id: string) => {
        return {
          url: `/coupon/${id}`,
          method: "DELETE",
        };
      },
    }),
    // Active - DeActive
    activeDeactiveCoupon: builder.mutation({
      invalidatesTags: ["coupon"],
      query: (id: string) => {
        return {
          url: `/coupon/status-change/${id}`,
          method: "PUT",
        };
      },
    }),
  }),
});

export const {
  useGetAllCouponWithPaginationQuery,
  useAddCouponMutation,
  useEditCouponMutation,
  useViewCouponByIdQuery,
  useGetCouponByCodeMutation,
  useDeleteCouponMutation,
  useActiveDeactiveCouponMutation,
} = couponApi;
